// Indonesian formatting, one place. Numbers group with a dot ("1.284"),
// times use the id-ID clock ("09.12"), dates use short month names.
const number = new Intl.NumberFormat("id-ID");
const dateTime = new Intl.DateTimeFormat("id-ID", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
const date = new Intl.DateTimeFormat("id-ID", { day: "numeric", month: "short", year: "numeric" });
const time = new Intl.DateTimeFormat("id-ID", { hour: "2-digit", minute: "2-digit" });
const clock = new Intl.DateTimeFormat("id-ID", { hour: "2-digit", minute: "2-digit", second: "2-digit" });

export function formatNumber(n: number): string {
  return number.format(n);
}

/** "14 Okt 09.12" */
export function formatDateTime(iso: string): string {
  return dateTime.format(new Date(iso));
}

/** "14 Okt 2026" */
export function formatDate(iso: string): string {
  return date.format(new Date(iso));
}

/** "14.32.05" */
export function formatClock(d: Date): string {
  return clock.format(d);
}

/** A 6-digit pairing code grouped for reading aloud: "482 913". */
export function formatCode(code: string): string {
  return code.length === 6 ? `${code.slice(0, 3)} ${code.slice(3)}` : code;
}

/** "09.12", the time of day only (records already sit under a dated header). */
export function formatTime(iso: string): string {
  return time.format(new Date(iso));
}
